"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiContact = void 0;
const utils_1 = require("@dev-stream/utils");
const utils_2 = require("@dev-stream/utils");
class OpenApiContact extends utils_1.BaseModel {
    constructor() {
        super(...arguments);
        this.BASE_TYPE = OpenApiContact;
    }
    GetDefaultValue() {
        return {};
    }
    static isOpenApiContact(obj) {
        return (obj instanceof OpenApiContact ||
            (0, utils_2.hasUnionKeys)(obj, ["email", "name", "url"]));
    }
}
exports.OpenApiContact = OpenApiContact;
